import React, { useEffect, useState } from 'react';
import '../../common/css/groupRequest.css';
import SaveModal from '../modal/saveModal';
import GroupReservation from '../service/reservationNumber/groupReservation';
import axios from 'axios';
import Loader from '../common/loader';
import GroupEmailReservation from '../service/reservationNumber/groupEmailReservation';
import moment from 'moment';
import GetIATAModal from '../modal/signUpGetIATAModal';

function GroupRequest() {
    const [IsStatus, setIsStatus] = useState('BSP');
    const [IsNull, setIsNull] = useState('');
    const [ticketIsStatus, setTicketIsStatus] = useState('BSP');
    const [agencyId, setagencyId] = useState(''); // 대리점 ID
    const [IsWait, setIsWait] = useState(false);
    const [checkIATACode, setCheckIATACode] = useState(true);
    const [agencyData, setagencyData] = useState([]);
    const [PRFlightScheduleList, setPRFlightScheduleList] = useState([]); // 운항스케쥴정보
    const [PRRouteList, setPRRouteList] = useState([]); // 노선정보

    // 입력값
    const [ticketingType, setTicketingType] = useState('BSP'); // 발권 형태
    const [groupName, setGroupName] = useState(''); // 단체명
    const [groupTotal, setGroupTotal] = useState(''); // 인원
    const [agencyCode, setagencyCode] = useState(''); // 대리점 ID
    const [memo, setMemo] = useState(''); // 메모/요청사항
    const [agentType, setAgentType] = useState('BSP'); // 발권 형태
    const [IATACode, setIATACode] = useState(''); // IATA 코드
    const [BusinessNum, setBusinessNum] = useState(''); // 사업자 등록 번호
    const [AgencyName, setAgencyName] = useState(''); // 대리점명
    const [userName, setUserName] = useState(''); // 담당자명
    const [DirectNum, setDirectNum] = useState(''); // 직통번호
    const [userPhone, setUserPhone] = useState(''); // 전화번호
    const [segments, setSegments] = useState([]);
    const [emailSegments, setEmails] = useState([]); // 이메일 주소 추가

    // 모달 액션
    const [modalAction, setModalAction] = useState(null);
    const [modalTitle, setModalTitle] = useState();
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    // 항공편명 LIST 
    useEffect( async () =>  {
        try {
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const result = await axios.get(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/group/flightScheduleInfo`
            );

            setPRFlightScheduleList(result.data)

            const routeList = await axios.get(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/group/route`
            );

            setPRRouteList(routeList.data)
        } catch (error) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('편명 리스트 가져오던 중 오류가 발생했습니다.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
        }
    }, []);

    useEffect(() => {
            const departDate = segments[0]?.date;
            const flightNo = segments[0]?.flightNo;
            const routeFrom = segments[0]?.routeFrom;
            const routeTo = segments[0]?.routeTo;

            // 출발일, 편명, 구간 일치여부 확인
            if (departDate && flightNo && routeFrom && routeTo && routeFrom.length === 3 && routeTo.length === 3) {
                const route = `${routeFrom}-${routeTo}`

                // 한비노선인지 체크!!
                const isKorRoute = PRRouteList.filter(rt => rt.outbound === route || rt.inbound === route);
                // PR편인지 체크!!(편명의 앞 두글자가 숫자로만 되어 있거나 PR로 시작하면 PR편이다!)
                const isPRFlight = flightNo.startsWith('PR');

                if (isPRFlight && isKorRoute.length > 0) {
                    // 입력한 출발일의 시즌이 아직 항공스케쥴에 등록되지 않았다면 그 전 시즌껄로 비교한다!
                    // 가져온 항공스케쥴의 endDate MAX값을 구해서 입력한 출발일이 max값을 넘는지 체크! 넘으면 max값으로 치환!
                    const maxEndDate = new Date(Math.max(...PRFlightScheduleList.map(flight => new Date(flight.endDate))));
                    const isOverEndDate = (new Date(departDate) > maxEndDate);

                    // PR편명이고 한비노선일 경우만 출발일-편명-구간 체크하기!
                    const flightScheduleCheck = PRFlightScheduleList.filter(flight => checkFlightSchedule(flight,(isOverEndDate ? maxEndDate.toISOString().split('T')[0] : departDate),flightNo,route));
                    
                    if(flightScheduleCheck.length === 0){
                        setModalAction(() => () => setSaveStatus(true));
                        setModalContent('편명과 노선이 일치하지 않습니다.');
                        setSaveStatus(false);
                        setModalTitle('');
                        setIsWait(false);
                        segments[0].routeFrom = ''
                        segments[0].routeTo = ''
                    }
                }
            }
        
    }, [segments]);

    useEffect(() => {
        if (IsNull == 'IATA') {
            setModalAction(() => () => setSaveStatus(true));
            setModalTitle('IATA코드가 검색되지 않습니다.');
            setModalContent('사업자 등록 번호로 조회해 주세요.');
            setSaveStatus(false);
            setIsStatus('');
        }
    }, [IsNull]);

    useEffect(() => {
        if (saveStatus == false) {
            const onKeyDown = (e) => {
                if (e.key == 'Enter') {
                    setSaveStatus(true);
                    setIsNull('');
                }
            };
            window.addEventListener('keydown', onKeyDown);
            return () => window.removeEventListener('keydown', onKeyDown);
        }
    }, [saveStatus]);

    const agentStatusSelect = (e) => {
        const value = e.target.value;
        setBusinessNum('');
        setIATACode('');
        setAgencyName(null);
        setagencyData([]);
        setIsNull('')
        setIsStatus(value);
        setAgentType(value);
    };

    const receiveModalData = (data) => {
        setagencyData(data);
        setBusinessNum(data.saupNumb);
        setIATACode(data.iataCode);
        setAgencyName(data.kornName);
    };

    const ticketingStatusSelect = (e) => {
        const value = e.target.value;
        setTicketingType(value);
        setTicketIsStatus(value);
    };

    // 단체 견적 요청 버튼 클릭
    const handleSubmit = async () => {
        setIsWait(true);
        // 구간정보 검증
        const segmentCheck = segments.some(
            (segment) =>
                segment.routeFrom === '' ||
                segment.routeTo === '' ||
                segment.date === '',
        );

        let segmentDateCheck = ''
        if(segments.length > 1 ){
            for (let i = 0; i < segments.length; i++) {
                const segment = segments[i];
            
                if (segmentDateCheck !== '' && segmentDateCheck > segment.date) {
                    segmentDateCheck = true;
                    break;
                }
            
                segmentDateCheck = segment.date;
            }
            segmentDateCheck = segmentDateCheck == true ? segmentDateCheck : false
        }
        
        // 이메일 검증
        const emailSegmentsCheck = emailSegments.filter((segment) => segment.email.trim() !== '');
        if (groupName == '') {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('단체명을 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (groupTotal === '') {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('인원수를 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (segmentCheck) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('구간 정보를 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (segmentDateCheck) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('출발일자를 재설정 해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (agentType === 'ATR' && BusinessNum.length < 10) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('사업자등록번호를 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (agentType === 'BSP' && IATACode.length < 8) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('IATACODE를 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (agencyData == 0) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('IATA CODE 또는 사업자번호 조회해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (userName === '') {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('담당자명을 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (DirectNum === '') {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('직통번호를 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (userPhone === '' || !(/^01[016789]-?\d{3,4}-?\d{4}$/).test(userPhone)) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('핸드폰번호를 입력 또는 올바르게 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        } else if (emailSegmentsCheck.length === 0) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('이메일을 입력해주세요.');
            setSaveStatus(false);
            setModalTitle('');
            setIsWait(false);
            return false;
        }

        // 단체 견적 요청 API 호출
        try {
            const segmentsList = [];
            segments.map((segment) => {
                segmentsList.push({
                    id: '',
                    date: moment(segment.date).format('YYYY-MM-DD'),
                    flightNo: segment.flightNo,
                    route: `${segment.routeFrom}-${segment.routeTo}`,
                });
            });

            const ticketingType = 'BSP';

            const data = {
                ticketingType,
                groupName,
                groupTotal,
                segments: segmentsList,
                agencyData,
                memo,
                agentType,
                IATACode,
                BusinessNum,
                agencyCode,
                userName,
                DirectNum,
                userPhone,
                emailSegments,
            };

            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            await axios.post(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/group/agency/request`,
                {
                    data,
                },
            );

            setModalAction(() => () => window.location.replace('/'));
            setModalTitle('단체 견적 문의가 접수되었습니다.');
            setModalContent(
                '입력하신 이메일 주소로 담당자가 확인 후\n순차적으로 회신드릴 예정입니다.',
            );
            setSaveStatus(false);
            setIsWait(false);
        } catch (error) {
            if(error.response.data.message === 'NoKorAirports'){
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('한국-필리핀 구간이 포함된 여정만 요청이 가능합니다. \n문의하신 구간은 필리핀항공 본사 홈페이지에서 \n접수해주세요.\n www.philippineairlines.com');
                setSaveStatus(false);
                setModalTitle('');
                setIsWait(false);
            }else{
                setModalAction(() => () => setSaveStatus(true));
                setModalContent(error.response.data.message);
                setSaveStatus(false);
                setModalTitle('');
                setIsWait(false);
            }
        }
    };

    // iataCode/사업자등록번호 검색
    const searchIATAOrBusinessNum = async (e) => {
        const status = e.target.id ?? '';

        if (status === 'iataCode') {
            // 서버 통신후 존재하지 않는다면
            try {
                if (IATACode.length < 8) {
                    setModalAction(() => () => setSaveStatus(true));
                    setModalContent('IATACODE를 입력해주세요.');
                    setSaveStatus(false);
                    return;
                }
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
                    isLocal = true;
                } else {
                    isLocal = false;
                }
                const checkCode = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/signup/code?status=${status}&code=${IATACode}`,
                );
                setagencyData(checkCode.data);
                setagencyCode(checkCode.data.agentCode);
                setAgencyName(checkCode.data.kornName);
                setagencyId(checkCode.data.id);
            } catch (error) {
                setIsNull('IATA');
                setAgencyName('');
            }
        } else if (status === 'businessNum') {
            // 서버 통신후 존재하지 않는다면
            try {
                setIsWait(true);
                if (BusinessNum.length < 10) {
                    setModalAction(() => () => setSaveStatus(true));
                    setModalContent('사업자번호는 10자 입력 필수 입니다.');
                    setSaveStatus(false);
                    setIsWait(false);
                    return false;
                } else {
                    const hostname = window.location.hostname;
                    let isLocal = null;
                    if (hostname === 'wpal.philippineair.co.kr') {
                        isLocal = true;
                    } else {
                        isLocal = false;
                    }
                    const checkCode = await axios.get(
                        `${
                            isLocal
                                ? process.env.REACT_APP_PRODUCTION_API_URL
                                : process.env.REACT_APP_LOCAL_API_URL
                        }/wpal/signup/code?status=${status}&code=${BusinessNum}`,
                    );

                    setCheckIATACode(!checkCode.data.iataCode);
                    if (checkCode.data.iataCode) {
                        setIATACode(checkCode.data.iataCode);
                    }
                    setagencyCode(checkCode.data.agentCode);
                    setagencyData(checkCode.data);
                    setagencyId(checkCode.data.id);
                    setAgencyName(checkCode.data.kornName);
                    setIsWait(false);
                }
            } catch (error) {
                console.log(123);
                setIsWait(false);
                setIsNull('Business');
                setAgencyName('');
            }
        } else {
            setIsNull('');
        }
    };

    // 입력한 첫번째 세그의 출발일,편명,구간이 항공스케쥴과 일치하면 true
    function checkFlightSchedule(flight,dDate,flightNo,route) {
        const sDate = flight.startDate; // 항공스케쥴 - 운항 시작일
        const eDate = flight.endDate; // 항공스케쥴 - 운항 종료일
        const oFlightNo = flight.outbound_flightNo; // 항공스케쥴 - 아웃바운드편명
        const iFlightNo = flight.inbound_flightNo; // 항공스케쥴 - 인바운드편명
        const oRoute = flight.AdminRoute.outbound; // 항공스케쥴 - 아웃바운드노선
        const iRoute = flight.AdminRoute.inbound; // 항공스케쥴 - 인바운드편명

        // 항공스케쥴의 운항 시작일과 종료일사이에 해당되는 출발일인지 체크
        const checkDate = (new Date(dDate).setHours(9) >= new Date(sDate) && new Date(dDate) <= new Date(eDate));

        // 항공스케쥴의 아웃바운드편명과 아웃바운드노선에 일치하는지 체크
        const checkOutboundFlightNo = ((oFlightNo.replace('PR', '') === flightNo.replace('PR', '')) && (oRoute === route));
        // 항공스케쥴의 인바운드편명과 인바운드노선에 일치하는지 체크
        const checkInboundFlightNo = ((iFlightNo.replace('PR', '') === flightNo.replace('PR', '')) && (iRoute === route));

        // 항공스케쥴의 운항스케쥴에 해당되고, 아웃바운드 or 인바운드 편명과 노선에 일치하면 true
        if ((checkDate && checkOutboundFlightNo) || (checkDate && checkInboundFlightNo)) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <>
            {IsWait && <Loader />}
            <div className='bodyContainer'>
                <div className='subp_h_wrap'>
                    <div className='subp_h_list subp_h_home'>
                        <div>단체견적/발권</div>
                        <div>단체 견적 문의</div>
                        <div>요청하기</div>
                    </div>
                </div>
                <div id='contents'>
                    <div className='signUpFromWrap'>
                        <div className='page_hgroup'>
                            <h2 className='title'>여행사 단체 견적 문의</h2>
                        </div>
                        {/* 단체 정보 */}
                        <div className='agentCheckWrap'>
                            <h4>단체 정보</h4>

                            <table className='signUp-table'>
                                <tbody>
                                    {/*<tr className='firstTable-border'>
                                        <th className='firstTable'>
                                            <span className='important-value'>*</span>
                                            발권 형태
                                        </th>
                                        <td>
                                            <label className='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    name='travelType'
                                                    value='BSP'
                                                    onClick={ticketingStatusSelect}
                                                    defaultChecked
                                                />
                                                BSP 발권
                                            </label>
                                            <label className='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    name='travelType'
                                                    value='ATR'
                                                    onClick={ticketingStatusSelect}
                                                />
                                                항공사에 발권 요청(ATR 발권)
                                            </label>
                                        </td>
                                    </tr> */}
                                    <tr className='firstTable-border'>
                                        <th>
                                            <span className='important-value'>*</span>단체명
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='gourpName'
                                                    value={groupName}
                                                    onChange={(e) => setGroupName(e.target.value)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>인원
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding wpal-passenger-count-wrap'>
                                                <div className='wpal-each-wrap'>
                                                    <span className='wpal-grouptotal'>총</span>
                                                    <input
                                                        type='text'
                                                        id='grouptotal'
                                                        value={groupTotal}
                                                        onChange={(e) => {
                                                            let val = e.target.value.replace(
                                                                /[^0-9]/g,
                                                                '',
                                                            );
                                                            if (val) {
                                                                let number = parseInt(val, 10);
                                                                if (number > 999) {
                                                                    number = 999;
                                                                }
                                                                setGroupTotal(number);
                                                            } else {
                                                                setGroupTotal('');
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <GroupReservation onChangeSegments={setSegments} />
                                    <tr className='wpal-tr-resize'>
                                        <th>
                                            <span className='wpal-not-important-value'></span>
                                            메모/요청사항
                                        </th>
                                        <td className='table-padding'>
                                            <textarea
                                                style={{ display: 'block' }}
                                                className='wpal-group-textarea'
                                                placeholder='요청 스케줄(오전편/오후편), 국내/국제 이원구간 연결 시간 추천, 대체 가능 날짜 등'
                                                value={memo}
                                                onChange={(e) => setMemo(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            <a target='_blank' href="https://www.philippineairlines.com/ph/en/flight-timetable-page.html" style={{"position":"relative", top:"20px", "textDecoration":"underline", color:"#1E2D5F", fontWeight: '500'}}>* 필리핀항공 전 노선 운항 스케줄</a>
                            </table>
                        </div>
                        <div className='agentCheckWrap'>
                            <h4>여행사 정보</h4>

                            <table className='signUp-table'>
                                <tbody>
                                    <tr className='firstTable-border'>
                                        <th className='firstTable'>
                                            <span className='important-value'>*</span>
                                            여행사 구분
                                        </th>
                                        <td>
                                            <label className='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    name='agentType'
                                                    value='BSP'
                                                    onClick={agentStatusSelect}
                                                    defaultChecked
                                                />
                                                BSP
                                            </label>
                                            <label className='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    name='agentType'
                                                    value='ATR'
                                                    onClick={agentStatusSelect}
                                                />
                                                ATR
                                            </label>
                                        </td>
                                    </tr>
                                    <tr
                                        className={
                                            IsStatus === 'BSP' || IsStatus === '' ? '' : 'hide'
                                        }
                                    >
                                        <th>
                                            <span className='important-value'>*</span>IATA 코드
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='iataCode'
                                                    placeholder='IATA CODE'
                                                    value={IATACode}
                                                    maxLength={8}
                                                    onChange={(e) =>
                                                        setIATACode(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <button
                                                    className={`each-button ${
                                                        IsStatus === '' ? 'hide' : ''
                                                    }`}
                                                    id='iataCode'
                                                    onClick={searchIATAOrBusinessNum}
                                                >
                                                    조회
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        className={
                                            IsStatus === 'ATR' || IsStatus === '' ? '' : 'hide'
                                        }
                                    >
                                        <th>
                                            <span className='important-value'>*</span>사업자 등록
                                            번호
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='businessRegistrationNumber'
                                                    placeholder='사업자 등록 번호'
                                                    maxLength={10}
                                                    value={BusinessNum}
                                                    minLength={10}
                                                    onChange={(e) =>
                                                        setBusinessNum(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <button
                                                    className='each-button'
                                                    id='businessNum'
                                                    onClick={searchIATAOrBusinessNum}
                                                >
                                                    조회
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>
                                            대리점명
                                        </th>
                                        <td>
                                            <div className='table-padding'>{AgencyName}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* 회원 정보 */}
                        <div className='agentCheckWrap'>
                            <h4>담당자 정보</h4>

                            <table className='signUp-table'>
                                <tbody>
                                    <tr className='firstTable-border'>
                                        <th>
                                            <span className='important-value'>*</span>
                                            담당자명
                                        </th>
                                        <td>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    className='signUp'
                                                    id='userName'
                                                    placeholder='담당자명'
                                                    value={userName}
                                                    onChange={(e) => setUserName(e.target.value)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>직통번호
                                        </th>
                                        <td>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='DirectNum'
                                                    placeholder='`-`없이'
                                                    value={DirectNum}
                                                    onChange={(e) =>
                                                        setDirectNum(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                    onBlur={() => {
                                                        if (DirectNum.length === 9) {
                                                            setDirectNum(DirectNum.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'));
                                                        } else if (DirectNum.length === 10 && DirectNum.startsWith('02')) {
                                                            setDirectNum(DirectNum.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3'));
                                                        } else if (DirectNum.length === 10) {
                                                            setDirectNum(DirectNum.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
                                                        } else if (DirectNum.length === 11) {
                                                            setDirectNum(DirectNum.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>핸드폰번호
                                        </th>
                                        <td>
                                            <div className='table-padding input-button' style={{paddingBottom: '10px'}}>
                                                <input
                                                    type='text'
                                                    id='userPhone'
                                                    placeholder='`-`없이'
                                                    value={userPhone}
                                                    onChange={(e) =>
                                                        setUserPhone(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                    onBlur={() => {
                                                        if (userPhone.length === 10) {
                                                        setUserPhone(userPhone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
                                                        } else if (userPhone.length === 11) {
                                                        setUserPhone(userPhone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'));
                                                        }
                                                    }}
                                                    maxLength={11}
                                                />
                                        
                                            </div>
                                            <span className='authNumberTxt table-padding'>
                                            * 지연 및 결항 시 안내 문자가 전송됩니다.
                                            <span className='wpal-authNumberTxt-next-line'></span>
                                        </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>e-mail
                                        </th>
                                        <GroupEmailReservation onChangeSegments={setEmails} />
                                        <span className='authNumberTxt table-padding'>
                                            * 단체 견적 문의 및 단체 예약/발권 관련 모든 안내는 위에
                                            입력하신 이메일 주소로 발송됩니다.
                                            <span className='wpal-authNumberTxt-next-line'>
                                                메일 수신이 필요한 모든 담당자의 이메일 주소를
                                                입력하시기 바랍니다.
                                            </span>
                                        </span>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='submitArea'>
                            <button
                                className='each-button btn46 red'
                                onClick={() => handleSubmit()}
                            >
                                단체 견적 요청
                            </button>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '60px', padding: '115px 0 0' }}>
                        <div>
                            <div className='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                                <h3>단체 예약 신청 조건</h3>
                            </div>
                            <table
                                className='table_style3 bdt'
                                cellPadding='0'
                                cellSpacing='0'
                                id='privateInfoTbl'
                            >
                                <colgroup>
                                    <col style={{ width: '50%' }} />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        {/*prettier-ignore */}
                                        <td className='infoTable' style={{padding:'10px', borderBottom:'unset'}}>
                            <strong>1. <strong className='wpal-strong-point-text'>성인 10명</strong> 이상의 구성원이 동일한 여정으로 예약.</strong><br />
                            <strong>2. Deposit 입금 이후에는 일정 변경 불가</strong><br />
                            <strong>3. <strong className='wpal-strong-point-text'>전 구간</strong> NO FOC, NO CHD</strong><br />
                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            {/*<div className='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                                <h3>FOC 지급 조건</h3>
                            </div>
                            <table
                                className='table_style3 bdt'
                                cellpadding='0'
                                cellspacing='0'
                                id='privateInfoTbl'
                            >
                                <colgroup>
                                    <col style={{ width: '100%' }} />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        prettier-ignore 
                                        <td className='infoTable' style={{padding:'10px', borderBottom:'unset'}}>
                                            <strong>1. 그룹 인원수에 관계 없이 <strong className='wpal-strong-point-text'>그룹당 1FOC 제공.</strong></strong><br />
                                            <strong>2. 성인 기준 16명 이상인 경우에만 적용되며, 소아는 2명당 1명으로 간주.</strong><br />
                                            <strong>3. 국제 + 국내 ADD-ON 예약과 편도 예약은 NO FOC 적용.</strong><br />
                                            <strong>4. FOC는 PR 그룹데스크를 통한 예약만 지급.</strong><br />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>*/}
                        </div>
                    </div>
                </div>
                <SaveModal
                    content={modalContent}
                    SaveBtn={saveStatus}
                    onClose={modalAction}
                    title={modalTitle}
                />

                {IsNull === 'Business' && (
                    <GetIATAModal
                        IsNull={IsNull}
                        IsGroup={true}
                        onClose={() => setIsNull('')}
                        setModalAgencyData={receiveModalData}
                    />
                )}
            </div>
        </>
    );
}

export default GroupRequest;
